import React from 'react';
import MsrObservationText from './MsrObservationText';
import type { MsrObservationEntry } from './msrReportTypes';
import { normalizeMsrObservation } from './msrObservationParser';

export interface MsrObservationBoxProps {
  observations: MsrObservationEntry[];
}

const MsrObservationBox: React.FC<MsrObservationBoxProps> = ({ observations }) => {
  if (!observations.length) return null;

  return (
    <div className="mt-4 overflow-hidden rounded-xl border border-slate-200/90 bg-white shadow-sm shadow-slate-900/5 ring-1 ring-slate-950/[0.04]">
      <div className="relative border-b border-slate-100 bg-gradient-to-r from-slate-50 via-white to-indigo-50/40 px-4 py-3">
        <span
          className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-indigo-500 to-violet-500"
          aria-hidden
        />
        <h4 className="pl-2.5 text-sm font-semibold tracking-tight text-slate-800">Observations</h4>
      </div>
      <ul className="list-disc space-y-2 px-4 py-4 pl-8 text-sm leading-relaxed text-slate-700">
        {observations.map((entry, i) => {
          const { text, children } = normalizeMsrObservation(entry);
          return (
            <li key={i}>
              <MsrObservationText text={text} />
              {children && children.length > 0 ? (
                <ul className="mt-2 list-disc space-y-2 pl-5">
                  {children.map((child, j) => (
                    <li key={j}>
                      <MsrObservationText text={child} />
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MsrObservationBox;
